<template>
	<!-- 投诉建议弹窗 -->
	<el-dialog title="投诉建议" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
		<!-- 表单内容 -->
		<el-form :model="complaintForm" :rules="formRules" ref="complaintForm" label-width="100px">
			<!-- 联系方式输入框 -->
			<el-form-item label="联系方式" prop="contact">
				<el-input v-model="complaintForm.contact" placeholder="请输入您的手机号或邮箱" clearable />
			</el-form-item>

			<!-- 投诉建议文本域 -->
			<el-form-item label="投诉建议" prop="suggestion">
				<el-input type="textarea" v-model="complaintForm.suggestion" placeholder="请输入您的投诉建议内容" :rows="4"
					maxlength="500" show-word-limit />
			</el-form-item>
		</el-form>

		<!-- 底部按钮区域 -->
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取消</el-button>
			<el-button type="primary" @click="handleSubmit" :loading="submitLoading">
				提交
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				submitLoading: false,
				complaintForm: {
					contact: '',
					suggestion: ''
				},
				formRules: {
					contact: [{
						required: true,
						trigger: 'blur',
						message: '请输入'
					}],
					suggestion: [{
						required: true,
						trigger: 'blur',
						message: '请输入'
					}]
				}
			};
		},
		methods: {
			init() {
				this.dialogVisible = true
			},
			// 关闭弹窗前确认
			handleClose(done) {
				this.$confirm('确认关闭？未保存的内容将会丢失', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.resetForm();
					done();
				}).catch(() => {});
			},

			// 提交表单
			handleSubmit() {
				this.$refs.complaintForm.validate((valid) => {
					if (valid) {
						this.submitLoading = true;

						// 模拟异步提交
						setTimeout(() => {
							this.$message({
								type: 'success',
								message: '提交成功！我们会尽快处理您的反馈'
							});

							this.submitLoading = false;
							this.dialogVisible = false;
							this.resetForm();
						}, 1500);
					} else {
						this.$message.error('请完善表单信息');
					}
				});
			},

			// 重置表单
			resetForm() {
				this.$refs.complaintForm.resetFields();
			},
		}
	}
</script>

<style scoped>
</style>